export const REACT_APP_GA_TRACKING = process.env.REACT_APP_GA_TRACKING;
